<template>
  <v-container fluid>
    <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>

    <v-card class="card--flex-toolbar">
      <v-toolbar color="grey lighten-4" class="elevation-0" tabs>
        <v-toolbar-title>Deletar Clientes</v-toolbar-title>

        <v-tabs
          v-model="active"
          show-arrows
          slot="extension"
          color="grey lighten-4"
          slider-color="black"
        >
          <v-tab key="1" ripple>Cliente</v-tab>
        </v-tabs>
      </v-toolbar>

      <v-card-text>
        <v-tabs-items v-model="active" style="min-height:450px">
          <v-tab-item key="1">
            <v-form v-model="valid">
              <v-container fluid>
                <v-layout row wrap>
                  <!-- LINHA 1, CAMPO CODIGO -->
                  <v-flex xs12 sm6>
                    <v-text-field v-model="cliente.id" label="Código"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field v-model="cliente.nome" label="Nome" required></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn flat @click="$router.push('/clientes')">Voltar</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="excluir()">Excluir</v-btn>
      </v-card-actions>
    </v-card>

    <div style="margin:50px"></div>
  </v-container>
</template>
<script>
import { showFlash, showError } from '@/utils'
import clienteService from '@/services/cliente'

export default {
  name: 'clientes',
  data () {
    return {
      cliente: {},
      loading: false,
      valid: true,
      active: 0,
      modo: '',
      resultado: {}
    }
  },
  mounted: async function () {
    try {
      let id = this.$route.params.id
      this.loading = true
      this.cliente = await clienteService.getById(id)
    } catch (error) {
      showError(error)
    } finally {
      this.loading = false
    }
  },
  methods: {
    async excluir () {
      try {
        let clienteResult = await clienteService.delete(this.cliente.id)
        if (clienteResult.data.data !== undefined && clienteResult.data.data.id !== undefined) {
          this.cliente = clienteResult.data.data
        }
        showFlash('Excluido com sucesso')
      } catch (error) {
        showError(error)
      }
    }
  }
}
</script>
